import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserPreferencesAction, getEmailTemplateAction, createUserPreferenceAction } from "./actions";
import { Table, CardWithLable, Spinner } from "@public/ui-toolkit";
import { Switch } from 'antd';
import { alertService } from "@hedgefund/shared/src/Alert";

const UserPreference = () => {

  const getUserPreferencesState = useSelector((state) => state.UserPreferencesStore);
  const { getEmailTemplates, loading } = getUserPreferencesState;
  const onChange = (id) => {
    InsertUserPreferences(id);
  }

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserPreferencesAction());
    dispatch(getEmailTemplateAction());
  }, [dispatch]);
  const onSuccess = () => {
    alertService.success("Status Successfully Updated.", { autoClose: false });
  }

  const columns = [

    {
      name: "Subject",
      key: "subject",
    },
    {
      name: "Description",
      key: "description",
    },
    {
      name: "Enable",
      key: "id",
      renderContent: (email) => {
        return (<Switch defaultChecked={!email?.isPreference} onChange={() => onChange(email?.id)} />)
      }
    },
  ];

  const InsertUserPreferences = (id) => {
    var obj = { emailTemplateId: id };
    dispatch(createUserPreferenceAction(obj, onSuccess))
  }
  return (
    <div>
      <main>
        <div className="main-inner mt-5">
          <div className="container mt-5">
            <div>
              <h2 className="text-center">User Preference</h2>
            </div>
            {loading ? (
              <Spinner className="text-center" />
            ) : (
              <div
                className="
          edit-profile-container
          p-xxl-5 p-md-4 p-3
          box-shadow
          bg-white
          rounded-large
          mt-5
        "
              >
                <CardWithLable title={"User Preference"} >
                  <div className="hf-card2-body px-0 pb-0">
                    <div className="hf-table">
                      <Table columns={columns} data={getEmailTemplates} />
                    </div>
                  </div>
                </CardWithLable>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserPreference;
